import React, { useState, useEffect, useContext, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Input,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Spin,
  DatePicker,
  Breadcrumb,
  InputNumber,
  Alert,
  Typography,
  Divider
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { loadStockViewDetailsData } from '../../../appRedux/actions/CommonData'
import moment from 'moment'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { STOCK_LIST } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  removeSpacewithLowerCaseString,
  getDecryptID,
  StringIsNullOrEmpty,
  formatDigits,
  loadProductBatchesRowData,
  loadSearchSelectedProduct,
  checkRightspermissions,
  isEmptyObject,
  verifyPkgFeature
} from '../../../appRedux/actions'
import { PurchaseOrderType } from '../../../constants/PurchaseOrderType'
import AutoStockOrderModal from '../../../components/AutoStockOrderModal'
import { PartialStockUpdateEnums } from '../../../constants/PartialStockUpdateEnums'
import { PartialStockModalType } from '../../../constants/PartialStockModalType'
import { StockOrderTypesEnum } from '../../../constants/StockOrderTypesEnum'
import { StockOrderStatusTypesEnum } from '../../../constants/StockOrderStatusTypesEnum'
import ProductBatches from '../../../components/ProductBatches'
import ProductSearch from '../../../components/ProductSearch'
import ProductLink from '../../../components/ProductScreen/ProductLink'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const EditDetails = ({ match }) => {
  const isRecieved =
    !StringIsNullOrEmpty(match.params.isReceived) &&
    !StringIsNullOrEmpty(match.params.id)
      ? removeSpacewithLowerCaseString(match.params.isReceived) == 'true'
        ? true
        : false
      : false
  const dispatch = useDispatch()
  const history = useHistory()
  const stockOrderID = match.params.id

  //#region UseSelector
  const getReduxStockDetails = useSelector(
    ({ commonConfigs }) => commonConfigs.getStockViewDetailsData
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  const getReduxProductBatchesRowData = useSelector(
    ({ Products }) => Products.getProductBatchesRowData
  )

  //#endregion UseSelector

  //#region use State

  const [selected, setselected] = useState([])
  const [isShowProduct, setIsShowProduct] = useState(false)
  const [getIsLoading, setIsLoading] = useState(true)
  const [form] = Form.useForm()
  const [initialFormValue, setinitialFormValue] = useState()
  const [grandTotal, setgrandTotal] = useState(0)
  const [getSearchProd, setSearchProd] = useState([])
  const [supplierData, setSupplierData] = useState([])
  const [outletData, setOutletData] = useState([])
  const [getStockTypeID, setStockTypeID] = useState('')
  const [getStatusID, setStatusID] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [isRegistering, SetisRegistering] = React.useState(true)
  const [getStockTypeName, setStockTypeName] = useState('')
  const [getStockProductsColumn, setStockProductsColumn] =
    React.useState(columnsOrder)
  const [getIsOrderNumberExist, setIsOrderNumberExist] = useState(false)
  const [getStockPostData, setStockPostData] = useState([])
  const [getStockPartialPostData, setStockPartialPostData] = useState([])
  const [getProductStockModalData, setProductStockModalData] = useState([])
  const [getIsStockOrderModalActive, setIsStockOrderModalActive] =
    useState(false)
  const [getPartialStockUpdate, setPartialStockUpdate] = useState(
    PartialStockUpdateEnums.Default
  )
  const [getPartialStockModalType, setPartialStockModalType] = useState(
    PartialStockModalType.OrderStockModal
  )
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({})
  const [getShortCurr, setShortCurr] = useState('')
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //#endregion use State

  //#region UseEffect

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted && selected.length > 0) {
      let total = 0
      selected.forEach(data => {
        total += isRecieved
          ? parseFloat(data.receive * data.supplyPrice)
          : parseFloat(data.quantity * data.supplyPrice)
      })
      setgrandTotal(parseFloat(total))
    }

    return () => (mounted = false)
  }, [selected])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(STOCK_LIST))
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      getOutletsService()
      if (Object.keys(getReduxStockDetails).length == 0) {
        const stockObj = {
          StockOrderID: match.params.id
        }
        dispatch(loadStockViewDetailsData(stockObj, false))
      }
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (
        getReduxStockDetails &&
        getReduxStockDetails.data &&
        getReduxStockDetails.data.data
      ) {
        let res = getReduxStockDetails

        setIsLoading(false)
        let stockOrderTypeID =
          res.data.data.stockOrderTypeID != '' && res.data.data.stockOrderTypeID
            ? getDecryptID(res.data.data.stockOrderTypeID)
            : ''
        let stockOrderStatusTypeID =
          res.data.data.stockOrderStatusTypeID != '' &&
          res.data.data.stockOrderStatusTypeID
            ? getDecryptID(res.data.data.stockOrderStatusTypeID)
            : ''

        setStockTypeID(stockOrderTypeID)
        setStatusID(stockOrderStatusTypeID)
        setStockTypeName(res.data.data.stockTypeName)
        setIsShowProduct(true)
        if (
          stockOrderTypeID == StockOrderTypesEnum.OrderStock ||
          stockOrderTypeID == StockOrderTypesEnum.ReceiveStock
        ) {
          form.setFieldsValue({
            Outlet: res.data.data.deliverTo,
            Supplier: res.data.data.supplierName,
            Note: !StringIsNullOrEmpty(res.data.data.notes)
              ? res.data.data.notes
              : ' ',
            DeliveryDue: res.data.data.deliveryDue
              ? moment(res.data.data.deliveryDue)
              : '',
            OrderNo: !StringIsNullOrEmpty(res.data.data.orderNumber)
              ? res.data.data.orderNumber
              : ' ',
            SupplyInvoiceNumber: !StringIsNullOrEmpty(
              res.data.data.supplierInvoiceNumber
            )
              ? res.data.data.supplierInvoiceNumber
              : ' '
          })

          if (
            res.data.data.stockOrderDetailsProducts &&
            res.data.data.stockOrderDetailsProducts.length > 0
          ) {
            let productss = res.data.data.stockOrderDetailsProducts.map(e => {
              let orderQty = e.orderedQty ? parseInt(e.orderedQty) : 0
              let supplyPrice = e.supplyPrice ? parseFloat(e.supplyPrice) : 0
              let receivedQty = e.receivedQty
                ? parseFloat(e.receivedQty) === 0
                  ? orderQty
                  : parseFloat(e.receivedQty)
                : 0
              let productName = e.isVariant
                ? `${e.productName} (${e.variantName})`
                : e.productName
              return {
                orderNo: selected.length + 1,
                key: e.productID,
                productName: productName,
                quantity: orderQty,
                supplyPrice: supplyPrice,
                totalCost: parseFloat(supplyPrice * orderQty).toFixed(2),
                stockInHand: e.stockOnHand ? parseInt(e.stockOnHand) : 0,
                receive: receivedQty,
                batchLimit: e.batchLimit ? e.batchLimit : 0,
                isProductInventory: e.isProductInventory
              }
            })
            setselected(productss)
          }
        }

        if (stockOrderTypeID == StockOrderTypesEnum.ReturnStock) {
          form.setFieldsValue({
            Outlet: res.data.data.returnFrom,
            Supplier: res.data.data.deliverTo,
            Note: !StringIsNullOrEmpty(res.data.data.notes)
              ? res.data.data.notes
              : ' ',
            DeliveryDue: res.data.data.deliveryDue
              ? moment(res.data.data.deliveryDue)
              : '',
            OrderNo: !StringIsNullOrEmpty(res.data.data.returnNumber)
              ? res.data.data.returnNumber
              : ' ',
            SupplyInvoiceNumber: !StringIsNullOrEmpty(
              res.data.data.supplierInvoiceNumber
            )
              ? res.data.data.supplierInvoiceNumber
              : ' ',
            NameRef: !StringIsNullOrEmpty(res.data.data.referenceName)
              ? res.data.data.referenceName
              : ' '
          })

          if (
            res.data.data.stockOrderDetailsProducts &&
            res.data.data.stockOrderDetailsProducts.length > 0
          ) {
            let productss = res.data.data.stockOrderDetailsProducts.map(e => {
              let productName = e.isVariant
                ? `${e.productName} (${e.variantName})`
                : e.productName
              return {
                orderNo: selected.length + 1,
                key: e.productID,
                productName: productName,
                quantity: e.returnedQty ? parseInt(e.returnedQty) : 0,
                supplyPrice: e.supplyPrice
                  ? parseFloat(e.supplyPrice).toFixed(2)
                  : 0,
                totalCost: e.totalSupplyPrice
                  ? parseFloat(e.totalSupplyPrice).toFixed(2)
                  : 0,
                stockInHand: e.stockOnHand ? parseInt(e.stockOnHand) : 0,
                isProductInventory: e.isProductInventory
              }
            })
            setselected(selected.concat(productss))
          }
        }
        if (stockOrderTypeID == StockOrderTypesEnum.TransferStock) {
          form.setFieldsValue({
            From: res.data.data.sourceOutletName,
            To: res.data.data.deliverTo,
            Note: !StringIsNullOrEmpty(res.data.data.notes)
              ? res.data.data.notes
              : ' ',
            DeliveryDue: res.data.data.deliveryDue
              ? moment(res.data.data.deliveryDue)
              : '',
            OrderNo: !StringIsNullOrEmpty(res.data.data.referenceName)
              ? res.data.data.referenceName
              : ' ',
            NameRef: !StringIsNullOrEmpty(res.data.data.referenceName)
              ? res.data.data.referenceName
              : ' '
          })

          if (
            res.data.data.stockOrderDetailsProducts &&
            res.data.data.stockOrderDetailsProducts.length > 0
          ) {
            let productss = res.data.data.stockOrderDetailsProducts.map(
              (e, index) => {
                let productName = e.isVariant
                  ? `${e.productName} (${e.variantName})`
                  : e.productName
                return {
                  orderNo: index + 1,
                  key: e.productID,
                  productName: productName,
                  quantity: e.orderedQty ? parseInt(e.orderedQty) : 0,
                  supplyPrice: e.supplyPrice
                    ? parseFloat(e.supplyPrice).toFixed(2)
                    : 0,
                  totalCost: e.totalSupplyPrice
                    ? parseFloat(e.totalSupplyPrice).toFixed(2)
                    : 0,
                  stockInHand: e.stockOnHand ? parseInt(e.stockOnHand) : 0,
                  stockAtSource: e.stockAtSource
                    ? parseInt(e.stockAtSource)
                    : 0,
                  receive: e.receivedQty ? parseInt(e.receivedQty) : 0,
                  isProductInventory: e.isProductInventory
                }
              }
            )
            setselected(selected.concat(productss))
          }
        }

        //Set Selected Columns for table
        if (
          stockOrderTypeID == StockOrderTypesEnum.OrderStock ||
          stockOrderTypeID == StockOrderTypesEnum.ReturnStock
        ) {
          if (isRecieved) {
            setStockProductsColumn(columnsReceive)
          } else {
            setStockProductsColumn(columnsOrder)
          }
        } else if (stockOrderTypeID == StockOrderTypesEnum.TransferStock) {
          if (isRecieved) {
            setStockProductsColumn(columnsTransferReceive)
          } else {
            setStockProductsColumn(columnsTransfer)
          }
        }

        //   getStockTypeID ==
        //   (StockOrderTypesEnum.OrderStock ||
        //     getStockTypeID ==
        //       StockOrderTypesEnum.ReturnStock) &&
        // !isRecieved
        //   ? columnsOrder
        //   : getStockTypeID ==
        //       StockOrderTypesEnum.OrderStock &&
        //     isRecieved
        //   ? columnsReceive
        //   : getStockTypeID ==
        //       StockOrderTypesEnum.TransferStock &&
        //     !isRecieved
        //   ? columnsTransfer
        //   : getStockTypeID ==
        //       StockOrderTypesEnum.TransferStock &&
        //     isRecieved
        //   ? columnsTransferReceive
        //   : []
      } else {
        if (
          (getReduxStockDetails &&
            getReduxStockDetails.res &&
            getReduxStockDetails.res == 'Failed') ||
          (getReduxStockDetails &&
            getReduxStockDetails.data &&
            !getReduxStockDetails.data.data)
        ) {
          setIsLoading(false)
          dispatch(loadStockViewDetailsData('', true))
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxStockDetails])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getPartialStockUpdate != PartialStockUpdateEnums.Default) {
        if (
          getStockPostData &&
          getStockPostData.StockOrderProducts &&
          getStockPostData.StockOrderProducts.length > 0
        ) {
          postStockOrderService(
            getStockPostData,
            BEHAVIOUR_TYPE.POST,
            PkgFeatures.InventoryManagement
          ).then(() => {
            if (
              getPartialStockUpdate ==
              PartialStockUpdateEnums.UpdatePartialStock
            ) {
              // Here we can update the partial Stock API
              if (
                getStockPartialPostData &&
                getStockPartialPostData.StockOrderProducts &&
                getStockPartialPostData.StockOrderProducts.length > 0
              ) {
                postStockOrderService(
                  getStockPartialPostData,
                  BEHAVIOUR_TYPE.POST,
                  PkgFeatures.InventoryManagement
                )
              }
            }
          })
        }

        setPartialStockUpdate(PartialStockUpdateEnums.Default)
      }
    }
    return () => (mounted = false)
  }, [getPartialStockUpdate])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#endregion UseEffect

  //#region API Services

  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        // setIsLoading(false);
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data
              let outletssData = data.map(e => {
                return {
                  id: e.sOutletId.substring(0, e.sOutletId.indexOf('&')),
                  outlet: e.outletName
                }
              })
              setOutletData(outletssData)
            }
          }
        }
      })
      .catch(e => {
        // setIsLoading(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut("store.getState()"));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }
  async function postStockOrderService (body, behaviorType, featureID) {
    await ds
      .postStockOrder(body, behaviorType, featureID)
      .then(res => {
        dispatch(loadProductBatchesRowData([]))
        SetisRegistering(false)
        if (res.data.data) {
          message.success('Successfully Saved')
          history.push('/Dashboard/inventory/stockcontrol/stockcontrollist')
        }
      })
      .catch(error => {
        SetisRegistering(false)
        message.error('Something went wrong...')
      })
  }

  //#endregion API Services

  //#region Change Functions

  const handleFocus = event => event.target.select()

  const onReceiveChange = ({ target: { value } }, index, record) => {
    setselected(prevData => {
      const newData = [...prevData]
      const newItem = { ...newData[index] }
      newItem.receive = value
      newItem.totalCost = parseFloat(
        parseFloat(record.supplyPrice) * parseInt(value)
      ).toFixed(2)
      newData[index] = newItem
      return newData
    })
  }

  const onSupplyPriceChange = (
    { target: { value } },
    index,
    record,
    columnType
  ) => {
    setselected(prevData => {
      const newData = [...prevData]
      const newItem = { ...newData[index] }
      newItem.supplyPrice = value
      if (columnType === 'columnsOrder' || columnType === 'columnsTransfer') {
        newItem.totalCost = parseFloat(
          parseFloat(value) * parseInt(record.quantity)
        ).toFixed(2)
      }
      if (
        columnType === 'columnsReceive' ||
        columnType === 'columnsTransferReceive'
      ) {
        newItem.totalCost = parseFloat(
          parseFloat(value) * parseInt(record.receive)
        ).toFixed(2)
      }

      newData[index] = newItem
      return newData
    })
  }

  const onQuantityChange = ({ target: { value } }, index, record) => {
    setselected(prevData => {
      const newData = [...prevData]
      const newItem = { ...newData[index] }
      newItem.quantity = value
      newItem.totalCost = parseFloat(
        parseInt(value) * parseFloat(record.supplyPrice)
      ).toFixed(2)
      newData[index] = newItem
      return newData
    })
  }

  function validateInputNumber (rule, value) {
    if (value <= 0) {
      return Promise.reject('Please enter a number greater than zero')
    }
    return Promise.resolve()
  }

  function removeTableProd (e) {
    let data = selected.filter(a => a.key != e.key)
    setselected(data)
    if (data.length == 0) {
      setgrandTotal(0)
    }
  }

  const onSelect = async selectedObj => {
    let selectedOut = 0
    let selectedOutDes = 0

    if (getStockTypeID == StockOrderTypesEnum.TransferStock) {
      let outletName = form.getFieldValue('To')
      let outletNameDes = form.getFieldValue('From')
      selectedOut =
        outletData.length > 0 &&
        outletData.filter(
          a =>
            removeSpacewithLowerCaseString(a.outlet) ==
            removeSpacewithLowerCaseString(outletName)
        ).length > 0
          ? parseInt(
              outletData.filter(
                a =>
                  removeSpacewithLowerCaseString(a.outlet) ==
                  removeSpacewithLowerCaseString(outletName)
              )[0].id
            )
          : 0
      selectedOutDes =
        outletData.length > 0 &&
        outletData.filter(
          a =>
            removeSpacewithLowerCaseString(a.outlet) ==
            removeSpacewithLowerCaseString(outletNameDes)
        ).length > 0
          ? parseInt(
              outletData.filter(
                a =>
                  removeSpacewithLowerCaseString(a.outlet) ==
                  removeSpacewithLowerCaseString(outletNameDes)
              )[0].id
            )
          : 0
    } else {
      // let outletName = form.getFieldValue("Outlet")
      //   ? parseInt(form.getFieldValue("Outlet"))
      //   : 0;
      let outletName = form.getFieldValue('Outlet')
        ? form.getFieldValue('Outlet')
        : 'Main Outlet'
      selectedOut =
        outletData.length > 0 &&
        outletData.filter(
          a =>
            removeSpacewithLowerCaseString(a.outlet) ==
            removeSpacewithLowerCaseString(outletName)
        ).length > 0
          ? parseInt(
              outletData.filter(
                a =>
                  removeSpacewithLowerCaseString(a.outlet) ==
                  removeSpacewithLowerCaseString(outletName)
              )[0].id
            )
          : 0
    }

    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }
    if (!StringIsNullOrEmpty(productID)) {
      await ds
        .getBookSearchProd(
          `?keys=""&outletid=${''}&isstock=${true}&isInventory=${false}&isActiveProduct=${false}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
        )
        .then(response => {
          const productData = response.data
          if (productData.msgCode == 'GENERAL_SUCCESS') {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((e, seq) => {
                return {
                  orderNo: selected.length + 1,
                  key: e.productID,
                  productName: e.productName,
                  quantity: isRecieved ? 0 : e.quantity,
                  supplyPrice: e.supplyPrice
                    ? parseFloat(e.supplyPrice)
                    : parseFloat('0.00'),
                  totalCost: parseFloat(e.quantity * e.supplyPrice).toFixed(2),
                  stockInHand:
                    e.inventoryCount &&
                    e.inventoryCount.length > 0 &&
                    e.inventoryCount.filter(a => a.outletID == selectedOut)
                      .length > 0
                      ? e.inventoryCount.filter(
                          a => a.outletID == selectedOut
                        )[0].inventory
                      : 0,
                  stockAtSource:
                    e.inventoryCount &&
                    e.inventoryCount.length > 0 &&
                    e.inventoryCount.filter(a => a.outletID == selectedOutDes)
                      .length > 0
                      ? e.inventoryCount.filter(
                          a => a.outletID == selectedOutDes
                        )[0].inventory
                      : 0,
                  receive: 0
                }
              })
            }
          }
          if (productData.msgCode == 'GENERAL_ERROR') {
            message.error(productData.msgDescription)
          }
        })
        .catch(e => {
          //console.log("Product Search Issue", e)
        })

      if (newProd.length > 0) {
        if (selected.length > 0) {
          if (!selected.some(e => e.key === productID)) {
            setselected(selected.concat(newProd))
          } else {
            message.error(
              'Product already add, please increase quantity of that product'
            )
          }
        } else if (selected.length == 0) setselected(newProd)
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
      }
    }
  }

  const validateOrderNumber = (rule, value, callback) => {
    if (getStockTypeID == StockOrderTypesEnum.TransferStock) {
      callback()
    } else {
      let body = {
        OrderNumber: value,
        StockOrderID: stockOrderID,
        PurchaseOrderType:
          getStockTypeID == StockOrderTypesEnum.ReturnStock
            ? PurchaseOrderType.SupplierReturnNumber
            : PurchaseOrderType.OrderNumber
      }
      const getIsExist = ds.checkIsOrderNumberExist(body, BEHAVIOUR_TYPE.POST)
      getIsExist
        .then(response => {
          if (response) {
            setIsOrderNumberExist(response)
            callback('This order number already exists. Add a different one.')
          } else {
            callback()
          }
        })
        .catch(e => {})
    }
  }
  //#endregion Change functions

  //#region Table Columns
  var columnsOrder = [
    {
      title: 'Seq No',
      dataIndex: 'orderNo',
      key: 'orderNo'
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => {
        return <ProductLink ProductId={record.key} text={text} />
      }
    },
    {
      title: `Stock In Hand`,
      dataIndex: 'stockInHand',
      key: 'stockInHand',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: `${
        getStockTypeID == StockOrderTypesEnum.ReturnStock
          ? 'Returned'
          : 'Ordered Quantity'
      }`,
      dataIndex: 'quantity',
      key: 'quantity',
      editable: true,
      render: (text, record, index) => {
        function putQuantity () {
          let quantityName = `quantity${record.key}`
          form.setFieldsValue({
            [quantityName]: record.quantity ? parseFloat(record.quantity) : 0
          })
        }
        putQuantity()
        return getStatusID == StockOrderStatusTypesEnum.DispatchedOrders ? (
          <p>{text}</p>
        ) : (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`quantity${record.key}`}>
              <InputNumber
                type='number'
                width={'50'}
                value={text}
                min={1}
                onPressEnter={v => onQuantityChange(v, index, record)}
                onBlur={v => onQuantityChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.quantity !== prevRecord.quantity
      }
    },

    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record, index) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        function putSupplyPrice () {
          let supplyPriceName = `supplyPrice${record.key}`
          form.setFieldsValue({
            [supplyPriceName]: record.supplyPrice
              ? parseFloat(record.supplyPrice).toFixed(2)
              : 0
          })
        }
        putSupplyPrice()
        return getStatusID == StockOrderStatusTypesEnum.DispatchedOrders ? (
          <p>{text}</p>
        ) : (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`supplyPrice${record.key}`}>
              <Input
                prefix={getCurrSymbol}
                value={final}
                onPressEnter={v =>
                  onSupplyPriceChange(v, index, record, 'columnsOrder')
                }
                onBlur={v =>
                  onSupplyPriceChange(v, index, record, 'columnsOrder')
                }
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.supplyPrice !== prevRecord.supplyPrice
      }
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = parseFloat(
          record.quantity * record.supplyPrice
        ).toFixed(2)
        if (selected.length == 1) {
          setgrandTotal(totalCost)
        }
        return (
          <span>
            <strong>
              {getCurrSymbol}{' '}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0.00'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  var columnsReceive = [
    {
      title: 'Seq No',
      dataIndex: 'orderNo',
      key: 'orderNo'
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => {
        return <ProductLink ProductId={record.key} text={text} />
      }
    },
    {
      title: `Stock In Hand`,
      dataIndex: 'stockInHand',
      key: 'stockInHand',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: 'Ordered Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      editable: true,
      render: (text, record) => {
        return <strong>{text}</strong>
      }
    },
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   key: "quantity",
    //   editable: true,
    //   render: (text, record, index) => {
    //     function putQuantity() {
    //       let quantityName = `quantity${record.key}`;
    //       form.setFieldsValue({
    //         [quantityName]: record.quantity ? parseFloat(record.quantity) : 0,
    //       });
    //     }
    //     putQuantity();
    //     return (
    //       <Form
    //         form={form}
    //         name="ReturnStockForm"
    //         onFinish={onFinish}
    //         onFinishFailed={onFinishFailed}
    //         scrollToFirstError
    //       >
    //         <Form.Item style={{ margin: 0 }} name={`quantity${record.key}`}>
    //           <Input
    //             width={"50"}
    //             value={text}
    //             onPressEnter={(v) => onQuantityChange(v, index, record)}
    //             onBlur={(v) => onQuantityChange(v, index, record)}
    //             onFocus={handleFocus}
    //           />
    //         </Form.Item>
    //       </Form>
    //     );
    //   },
    //   shouldCellUpdate: (record, prevRecord) => {
    //     return record.quantity !== prevRecord.quantity;
    //   },
    // },
    {
      title: 'Received',
      dataIndex: 'receive',
      key: 'receive',
      editable: true,
      render: (text, record, index) => {
        function putReceive () {
          let receiveName = `receive${record.key}`
          form.setFieldsValue({
            [receiveName]: record.receive ? parseFloat(record.receive) : 0
          })
        }
        putReceive()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              style={{ margin: 0 }}
              name={`receive${record.key}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter a number'
                },
                {
                  validator: validateInputNumber
                }
              ]}
            >
              <InputNumber
                type='number'
                width={'50'}
                value={text}
                min={1}
                onPressEnter={v => onReceiveChange(v, index, record)}
                onBlur={v => onReceiveChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.receive !== prevRecord.receive
      }
    },
    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record, index) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        function putSupplyPrice () {
          let supplyPriceName = `supplyPrice${record.key}`
          form.setFieldsValue({
            [supplyPriceName]: record.supplyPrice
              ? parseFloat(record.supplyPrice).toFixed(2)
              : 0
          })
        }
        putSupplyPrice()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`supplyPrice${record.key}`}>
              <Input
                value={final}
                prefix={getCurrSymbol}
                onPressEnter={v =>
                  onSupplyPriceChange(v, index, record, 'columnsReceive')
                }
                onBlur={v =>
                  onSupplyPriceChange(v, index, record, 'columnsReceive')
                }
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.supplyPrice !== prevRecord.supplyPrice
      }
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = parseFloat(
          record.quantity * record.supplyPrice
        ).toFixed(2)

        // if (selected.length == 1) {
        //   setgrandTotal(totalCost);
        // }
        return (
          <span>
            <strong>
              {getCurrSymbol}{' '}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0.00'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  var columnsTransfer = [
    {
      title: 'Seq No',
      dataIndex: 'orderNo',
      key: 'orderNo'
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => {
        return <ProductLink ProductId={record.key} text={text} />
      }
    },
    {
      title: `Stock in Hand`,
      dataIndex: 'stockInHand',
      key: 'stockInHand',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: `Stock at Source`,
      dataIndex: 'stockAtSource',
      key: 'stockAtSource',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      editable: true,
      render: (text, record, index) => {
        function putQuantity () {
          let quantityName = `quantity${record.key}`
          form.setFieldsValue({
            [quantityName]: record.quantity ? parseFloat(record.quantity) : 0
          })
        }
        putQuantity()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`quantity${record.key}`}>
              <InputNumber
                width={'50'}
                value={text}
                min={1}
                onPressEnter={v => onQuantityChange(v, index, record)}
                onBlur={v => onQuantityChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.quantity !== prevRecord.quantity
      }
    },
    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record, index) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        function putSupplyPrice () {
          let supplyPriceName = `supplyPrice${record.key}`
          form.setFieldsValue({
            [supplyPriceName]: record.supplyPrice
              ? parseFloat(record.supplyPrice).toFixed(2)
              : 0
          })
        }
        putSupplyPrice()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`supplyPrice${record.key}`}>
              <Input
                prefix={getCurrSymbol}
                value={final}
                onPressEnter={v =>
                  onSupplyPriceChange(v, index, record, 'columnsTransfer')
                }
                onBlur={v =>
                  onSupplyPriceChange(v, index, record, 'columnsTransfer')
                }
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.supplyPrice !== prevRecord.supplyPrice
      }
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = record.quantity * record.supplyPrice
        if (selected.length == 1) {
          setgrandTotal(totalCost)
        }
        return (
          <span>
            <strong>
              {getCurrSymbol}{' '}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  const ReceivedQuantityHeader = () => (
    <div>
      <div>
        <IntlMessages id='stock.edit.receivequantity' />
      </div>
      <a className='primary-anchor' onClick={handleReceiveAll}>
        <IntlMessages id='stock.edit.receiveallproducts' />{' '}
      </a>
    </div>
  )

  const handleReceiveAll = () => {
    const updatedData = selected.map(item => ({
      ...item,
      receive: item.quantity
    }))
    // Update the form fields
    updatedData.forEach(item => {
      let receiveName = `receive${item.orderNo}`
      form.setFieldsValue({
        [receiveName]: item.quantity
      })
    })
    setselected(updatedData)
  }

  var columnsTransferReceive = [
    {
      title: 'Seq No',
      dataIndex: 'orderNo',
      key: 'orderNo'
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      render: (text, record) => {
        return <ProductLink ProductId={record.key} text={text} />
      }
    },
    {
      title: `Stock in Hand`,
      dataIndex: 'stockInHand',
      key: 'stockInHand',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: `Stock at Source`,
      dataIndex: 'stockAtSource',
      key: 'stockAtSource',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: 'Transferred quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      editable: false,
      render: (text, record) => {
        return (
          <Tooltip
            title={
              <span style={{ color: 'black' }}>
                <IntlMessages id='sell.sell.retrievesell.clicktordfit' />
              </span>
            }
            color={'#d5d6d7'}
          >
            <strong>{text}</strong>
          </Tooltip>
        )
      }
    },
    {
      title: <ReceivedQuantityHeader />,
      dataIndex: 'receive',
      key: 'receive',
      editable: true,
      render: (text, record, index) => {
        function putReceive () {
          let receiveName = `receive${record.orderNo}`
          form.setFieldsValue({
            [receiveName]: record.receive ? parseFloat(record.receive) : 0
          })
        }
        putReceive()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              style={{ margin: 0 }}
              name={`receive${record.orderNo}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter a number'
                },
                {
                  validator: validateInputNumber
                }
              ]}
            >
              <InputNumber
                type='number'
                min={1}
                value={text}
                onPressEnter={v => onReceiveChange(v, index, record)}
                onBlur={v => onReceiveChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.receive !== prevRecord.receive
      }
    },
    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record, index) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        function putSupplyPrice () {
          let supplyPriceName = `supplyPrice${record.key}`
          form.setFieldsValue({
            [supplyPriceName]: record.supplyPrice
              ? parseFloat(record.supplyPrice).toFixed(2)
              : 0
          })
        }
        putSupplyPrice()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item style={{ margin: 0 }} name={`supplyPrice${record.key}`}>
              <Input
                value={final}
                prefix={getCurrSymbol}
                onPressEnter={v =>
                  onSupplyPriceChange(
                    v,
                    index,
                    record,
                    'columnsTransferReceive'
                  )
                }
                onBlur={v =>
                  onSupplyPriceChange(
                    v,
                    index,
                    record,
                    'columnsTransferReceive'
                  )
                }
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.supplyPrice !== prevRecord.supplyPrice
      }
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = record.quantity * record.supplyPrice
        if (selected.length == 1) {
          setgrandTotal(totalCost)
        }
        return (
          <span>
            <strong>
              {getCurrSymbol}{' '}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  //#endregion Table Columns

  //#region Submit Functions
  const onFinish = values => {
    try {
      if (match.params.id && isShowProduct) {
        setIsLoading(true)
        let isStockPost = true
        const productInventory = []
        let partialProductInventory = []

        let postDataObject = {}
        let partialPostDataObject = {}
        let productStockModalData = []
        if (
          getStockTypeID == StockOrderTypesEnum.OrderStock ||
          getStockTypeID == StockOrderTypesEnum.ReceiveStock
        ) {
          if (selected.length <= 0) {
            message.warn('Please select products')
            setIsLoading(false)
            return
          } else {
            selected.forEach(data => {
              if (data.quantity > data.receive) {
                let remainingQuantity = isRecieved
                  ? parseInt(data.quantity) - parseInt(data.receive)
                  : 0
                // This is data for Partial Product post
                partialProductInventory.push({
                  ProductID: data.key,
                  ProductQuantity: remainingQuantity,
                  SupplyPrice: parseFloat(data.supplyPrice),
                  ReceivedQuantity: 0
                })
                productStockModalData.push({
                  ProductID: data.key,
                  ProductName: data.productName,
                  Quantity: remainingQuantity,
                  TotalCost:
                    parseFloat(remainingQuantity) * parseFloat(data.supplyPrice)
                })
              }
              productInventory.push({
                ProductID: data.key,
                ProductQuantity: parseInt(data.quantity),
                SupplyPrice: parseFloat(data.supplyPrice),
                ReceivedQuantity: isRecieved ? parseInt(data.receive) : 0
              })
            })
          }

          let productBatches = []
          if (isRecieved) {
            productBatches = getReduxProductBatchesRowData.flat()
          }
          //console.log(productBatches);

          postDataObject = {
            BehaviorName: 3,
            StockOrderID: match.params.id,
            SupplierInvoiceNumber: values.SupplyInvoiceNumber
              ? values.SupplyInvoiceNumber
              : '',
            DeliveryDate: values.DeliveryDue
              ? values.DeliveryDue.format()
              : moment().format(),
            OrderNumber: values.OrderNo ? values.OrderNo : '',
            Notes: values.Note ? values.Note : '',
            StockType: parseInt(StockOrderTypesEnum.OrderStock),
            IsReceived: isRecieved,
            StockOrderProducts: productInventory,
            ProductBatchesData: productBatches
          }

          if (partialProductInventory.length > 0) {
            isStockPost = false
            partialPostDataObject = {
              BehaviorName: 1,
              StockOrderID: match.params.id,
              AutoPartialStockOrder: 1,
              StockOrderProducts: partialProductInventory
            }
            //This state for using to post stock Data using API. Full Stock and Partial Stock data
            setStockPostData(postDataObject)
            setStockPartialPostData(partialPostDataObject)

            //This data just for display purpose
            setProductStockModalData(productStockModalData)
            setIsStockOrderModalActive(true)
            setPartialStockModalType(PartialStockModalType.OrderStockModal)
          }
        } else if (getStockTypeID == StockOrderTypesEnum.TransferStock) {
          if (selected.length <= 0) {
            message.warn('Please select products')
            setIsLoading(false)
            return
          } else {
            selected.forEach(data => {
              if (data.quantity > data.receive) {
                let remainingQuantity = isRecieved
                  ? parseInt(data.quantity) - parseInt(data.receive)
                  : 0
                // This is data for Partial Product post
                partialProductInventory.push({
                  ProductID: data.key,
                  ProductQuantity: remainingQuantity,
                  SupplyPrice: parseFloat(data.supplyPrice),
                  ReceivedQuantity: 0
                })
                productStockModalData.push({
                  ProductID: data.key,
                  ProductName: data.productName,
                  Quantity: remainingQuantity,
                  TotalCost:
                    parseFloat(remainingQuantity) * parseFloat(data.supplyPrice)
                })
              }

              productInventory.push({
                ProductID: data.key,
                ProductQuantity: parseInt(data.quantity),
                SupplyPrice: parseFloat(data.supplyPrice),
                ReceivedQuantity: isRecieved ? parseInt(data.receive) : 0
              })
            })
          }
          postDataObject = {
            BehaviorName: 3,
            StockOrderID: match.params.id,
            DeliveryDate: values.DeliveryDue
              ? values.DeliveryDue.format()
              : moment().format(),
            OrderNumber: values.OrderNo ? values.OrderNo : '',
            StockType: parseInt(StockOrderTypesEnum.TransferStock),
            IsReceived: isRecieved,
            StockOrderProducts: productInventory
          }

          if (partialProductInventory.length > 0) {
            isStockPost = false
            partialPostDataObject = {
              BehaviorName: 1,
              StockOrderID: match.params.id,
              AutoPartialStockOrder: 2,
              StockOrderProducts: partialProductInventory
            }
            //This state for using to post stock Data using API. Full Stock and Partial Stock data
            setStockPostData(postDataObject)
            setStockPartialPostData(partialPostDataObject)

            //This data just for display purpose
            setProductStockModalData(productStockModalData)
            setIsStockOrderModalActive(true)
            setPartialStockModalType(PartialStockModalType.TransferStockModal)
          }
        } else if (getStockTypeID == StockOrderTypesEnum.ReturnStock) {
          if (selected.length <= 0) {
            message.warn('Please select products')
            setIsLoading(false)
            return
          } else {
            selected.forEach(data => {
              productInventory.push({
                ProductID: data.key,
                ProductQuantity: parseInt(data.quantity),
                SupplyPrice: parseFloat(data.supplyPrice)
              })
            })
          }
          postDataObject = {
            BehaviorName: 3,
            StockOrderID: match.params.id,
            SupplierInvoiceNumber: values.SupplyInvoiceNumber
              ? values.SupplyInvoiceNumber
              : '',
            DeliveryDate: values.DeliveryDue
              ? values.DeliveryDue.format()
              : moment().format(),
            ReturnNumber: values.OrderNo ? values.OrderNo : '',
            ReferenceName: values.NameRef ? values.NameRef : '',
            StockType: parseInt(StockOrderTypesEnum.ReturnStock),
            IsReceived: false,
            StockOrderProducts: productInventory
          }
        }
        if (isStockPost) {
          postStockOrderService(
            postDataObject,
            BEHAVIOUR_TYPE.POST,
            PkgFeatures.InventoryManagement
          )
        }
      } else {
        message.error('Kindly report this, FAILED')
      }
    } catch (ex) {
      setIsLoading(false)
    }
  }
  const onFinishFailed = errorInfo => {
    message.error('Kindly Attend to Missing Input')
  }
  //#endregion Submit Functions

  //#region Components

  const formFieldsOrder = () => {
    const children = []
    children.push(
      <Col xl={8} lg={12} md={12} sm={24} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`OrderNo`}
          label={
            <>
              {getStockTypeID == StockOrderTypesEnum.ReturnStock ? (
                <IntlMessages id='stock.edit.return' />
              ) : getStockTypeID == StockOrderTypesEnum.TransferStock ? (
                <IntlMessages id='stock.edit.transfer' />
              ) : (
                <IntlMessages id='stock.edit.orderno' />
              )}
            </>
          }
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.promoadd.disperalert' />
            },
            {
              validator: validateOrderNumber
            }
          ]}
        >
          <Input size='large' />
        </Form.Item>
      </Col>,

      getStockTypeID == StockOrderTypesEnum.TransferStock && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`From`}
            label={<IntlMessages id='stock.edit.spurceout' />}
          >
            <Input disabled size='large' />
          </Form.Item>
        </Col>
      ),

      getStockTypeID == StockOrderTypesEnum.TransferStock && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`To`}
            label={<IntlMessages id='stock.add.delto' />}
          >
            <Input disabled size='large' />
          </Form.Item>
        </Col>
      ),

      getStockTypeID != StockOrderTypesEnum.TransferStock && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`Supplier`}
            label={<IntlMessages id='stock.add.supp' />}
          >
            <Input disabled size='large' />
          </Form.Item>
        </Col>
      ),

      getStockTypeID != StockOrderTypesEnum.TransferStock && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`Outlet`}
            label={<IntlMessages id='stock.add.delto' />}
          >
            <Input disabled size='large' />
          </Form.Item>
        </Col>
      ),

      <Col xl={8} lg={12} md={12} sm={24} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`DeliveryDue`}
          label={<IntlMessages id='stock.edit.deliverdue' />}
        >
          <DatePicker
            size='large'
            className='gx-mb-3 gx-w-100'
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>,

      (getStockTypeID == StockOrderTypesEnum.OrderStock ||
        getStockTypeID == StockOrderTypesEnum.ReceiveStock) && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`Note`}
            label={<IntlMessages id='stock.add.note' />}
          >
            <Input
              size='large'
              placeholder={<IntlMessages id='stock.add.noteplaceholder' />}
            />
          </Form.Item>
        </Col>
      ),

      getStockTypeID != StockOrderTypesEnum.TransferStock && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`SupplyInvoiceNumber`}
            label={<IntlMessages id='stock.edit.suppinvo' />}
          >
            <Input
              size='large'
              placeholder={<IntlMessages id='stock.edit.suppinvo' />}
            />
          </Form.Item>
        </Col>
      ),

      (getStockTypeID == StockOrderTypesEnum.TransferStock ||
        getStockTypeID == StockOrderTypesEnum.ReturnStock) && (
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`NameRef`}
            label={<IntlMessages id='stock.edit.nameref' />}
          >
            <Input
              size='large'
              placeholder={<IntlMessages id='stock.edit.nameref' />}
            />
          </Form.Item>
        </Col>
      )
    )

    return children
  }

  //endregion Components
  return (
    <>
      {!getIsDisableUpdate && isFeatureAllowed ? (
        <div className='Content-wrapper OrderStock-pg'>
          <Spin
            tip={<IntlMessages id='sell.cashlisting.cashloading' />}
            spinning={getIsLoading}
            size='large'
          >
            <AutoStockOrderModal
              productStockData={getProductStockModalData}
              isModalActive={getIsStockOrderModalActive}
              setIsStockOrderModalActive={setIsStockOrderModalActive}
              setPartialStockUpdate={setPartialStockUpdate}
              modalType={getPartialStockModalType}
            />
            <Breadcrumb separator='>'>
              <Breadcrumb.Item>
                <IntlMessages id='discount.inventory' />
              </Breadcrumb.Item>
              <Breadcrumb.Item
                className='custom-stock-hoverbreadcrumb'
                onClick={() =>
                  history.push('/Dashboard/inventory/stockcontrol')
                }
              >
                <IntlMessages id='stock.edit.stockcont' />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {getStockTypeID == StockOrderTypesEnum.OrderStock ? (
                  <IntlMessages id='stock.edit.stockorder' />
                ) : getStockTypeID == StockOrderTypesEnum.TransferStock ? (
                  <IntlMessages id='stock.edit.stocktrans' />
                ) : getStockTypeID == StockOrderTypesEnum.ReturnStock ? (
                  <IntlMessages id='stock.edit.stockreturn' />
                ) : (
                  <IntlMessages id='stock.edit.stockupdate' />
                )}
              </Breadcrumb.Item>
            </Breadcrumb>

            <div style={{ marginTop: isShowProduct ? 0 : 0 }}>
              <Row className='mt-4'>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <h1 className='mb-2'>
                    {/* {getStockTypeID == StockOrderTypesEnum.OrderStock.toString() ? (
             <IntlMessages id="stock.edit.orderstock" />
           ) : getStockTypeID == StockOrderTypesEnum.ReceiveStock.toString() ? (
             <IntlMessages id="stock.edit.recstockor" />
           ) : (
             ""
           )} */}
                    {getStockTypeName}
                  </h1>
                </Col>
              </Row>

              <div style={{ marginTop: isShowProduct ? 0 : 0 }}>
                <Card
                  className='gx-card Filters-wrapper No-BoxShadow'
                  title={<IntlMessages id='stock.add.detail' />}
                >
                  <Form
                    form={form}
                    name='ReturnStockForm'
                    className='ant-advanced-search-form product-search-form Filters-Form'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    scrollToFirstError
                  >
                    <Row>
                      {getStockTypeID == StockOrderTypesEnum.OrderStock ||
                      getStockTypeID == StockOrderTypesEnum.TransferStock ||
                      getStockTypeID == StockOrderTypesEnum.ReturnStock ? (
                        formFieldsOrder()
                      ) : (
                        <></>
                      )}
                    </Row>

                    <div>
                      {!isShowProduct && (
                        <Form.Item>
                          <div className='custom-returnstock-btn'>
                            <Row justify='end' gutter={18}>
                              <Col>
                                <Button
                                  className='custom-new-canbtn'
                                  type='primary'
                                  block
                                  // size="large"
                                  onClick={() => {
                                    history.push(
                                      '/Dashboard/inventory/stockcontrol/stockcontrollist'
                                    )
                                  }}
                                  size='large'
                                >
                                  <IntlMessages id='products.promoadd.canbtn' />
                                </Button>
                              </Col>

                              <Col>
                                <Button
                                  className='custom-searchbtn'
                                  type='primary'
                                  block
                                  htmlType='submit'
                                  size='large'
                                >
                                  <IntlMessages id='stock.add.savebtn' />
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </Form.Item>
                      )}
                    </div>
                  </Form>
                </Card>
              </div>

              {isShowProduct && (
                <Card
                  className='gx-card No-BoxShadow card-padd inventory-box'
                  title={
                    <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                      <IntlMessages id='products.addpricebook.products' />
                    </h2>
                  }
                >
                  {!isRecieved &&
                  getStatusID == StockOrderStatusTypesEnum.DispatchedOrders ? (
                    <Alert
                      message={
                        <IntlMessages id='stock.edit.purchaseorderindispatchedstate' />
                      }
                      type='info'
                      showIcon
                    />
                  ) : (
                    <Row className='m-0'>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <ProductSearch isLabel={false} />
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {(getStockTypeID == StockOrderTypesEnum.OrderStock ||
                        getStockTypeID == StockOrderTypesEnum.ReturnStock) &&
                        isRecieved && (
                          //columnsReceive
                          <Table
                            className='MinWidth-auto'
                            columns={columnsReceive}
                            expandable={{
                              expandedRowRender: (
                                record,
                                index,
                                indent,
                                expaned
                              ) => (
                                <>
                                  {' '}
                                  <Divider />
                                  {/* <ExpandedRowRenderBatches
                                  record={record}
                                  index={index}
                                /> */}
                                  <ProductBatches
                                    record={record}
                                    index={index}
                                    onFinish={onFinish}
                                    form={form}
                                    name={'ReturnStockForm'}
                                  />
                                  <Divider />
                                </>
                              ),

                              rowExpandable: record =>
                                record.VariantName !== 'Not Expandable'
                              //  expandRowByClick: true,
                            }}
                            dataSource={selected}
                            rowClassName={() => 'editable-row'}
                            pagination={false}
                            footer={false}
                          ></Table>
                        )}
                      {(getStockTypeID == StockOrderTypesEnum.OrderStock ||
                        getStockTypeID == StockOrderTypesEnum.ReturnStock) &&
                        !isRecieved && (
                          //columnsOrder

                          <Table
                            columns={columnsOrder}
                            dataSource={selected}
                            rowClassName={() => 'editable-row'}
                            pagination={false}
                            footer={false}
                          ></Table>
                        )}
                      {getStockTypeID == StockOrderTypesEnum.TransferStock &&
                        !isRecieved && (
                          //columnsTransfer
                          <Table
                            columns={columnsTransfer}
                            dataSource={selected}
                            rowClassName={() => 'editable-row'}
                            pagination={false}
                            footer={false}
                          ></Table>
                        )}
                      {getStockTypeID == StockOrderTypesEnum.TransferStock &&
                        isRecieved && (
                          //columnsTransferReceive
                          <Table
                            columns={columnsTransferReceive}
                            dataSource={selected}
                            rowClassName={() => 'editable-row'}
                            pagination={false}
                            footer={false}
                          ></Table>
                        )}
                    </Col>
                  </Row>

                  <Row className='text-right mt-3'>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <h1>
                        <IntlMessages id='stock.add.total' />: {getCurrSymbol}{' '}
                        {`${
                          grandTotal
                            ? formatDigits(grandTotal, getDefaultDecimalPlaces)
                            : '0.00'
                        }`}
                      </h1>
                    </Col>

                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form
                        form={form}
                        name='ReturnStockForm'
                        className='ant-advanced-search-form'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Button
                          className='custom-new-canbtn'
                          type='primary'
                          onClick={() => {
                            history.push(
                              '/Dashboard/inventory/stockcontrol/stockcontrollist'
                            )
                          }}
                          size='large'
                        >
                          <IntlMessages id='products.promoadd.canbtn' />
                        </Button>

                        <Button
                          className='custom-searchbtn'
                          type='primary'
                          htmlType='submit'
                          size='large'
                        >
                          <IntlMessages id='stock.add.savebtn' />
                        </Button>
                      </Form>
                    </Col>
                  </Row>
                </Card>
              )}
            </div>
          </Spin>
        </div>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}

export default EditDetails
